import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Chip, DateTimeStandard } from '@curves/ui-base';

import { parseDate } from '@Util/moment.util';
import { formatCurrencyFn, isEmpty, isFunction } from '@Util/utils';
import { CYCLE_PURCHASE_BILLING_ROUTER_URL } from '@Router/routerPath';
import { matchTaskStatusColors } from '@Local/CyclePurchase/staticData';
import { DateTimeDisplay } from '@Local/Components/RowLabel';
import {OverflowMenu} from '@Local/Components';
export const getCyclePurchaseVerificationBatchPaymentRowLabel = () => {
    return [
        {
            cellKey: 'fileTaskID',
            headerLabel: '編號',
            formatCell: (value, { taskID, taskStatus }) => {
                const canView = String(taskStatus) === '3' || String(taskStatus) === '4';
                if (!canView) return value;
                return (
                    <Link className={'text-decoration-underline text-secondary'} to={CYCLE_PURCHASE_BILLING_ROUTER_URL(taskID)}>
                        {value}
                    </Link>
                );
            },
        },
        {
            cellKey: 'validateDate',
            headerLabel: '檢核上傳日期',
            formatCell: (value) => {
                return <DateTimeDisplay date={value} />;
            },
        },
        {
            cellKey: 'settleDate',
            headerLabel: '送件扣款日期',
            formatCell: (value) => {
                if (!value) return '-';
                return <DateTimeDisplay date={value} />;
            },
        },
        {
            cellKey: 'taskStatusText',
            headerLabel: '狀態',
            align: 'center',
            formatCell: (taskStatusText, { taskStatus }) => {
                return <Chip color={matchTaskStatusColors(taskStatus)} label={taskStatusText} />;
            },
        },
        {
            cellKey: 'clubSystemTypeText',
            headerLabel: '店鋪類型',
            align: 'center',
        },
        {
            cellKey: 'shippingMonth',
            headerLabel: '出貨月份',
            align: 'center',
            formatCell: (value) => {
                return <Box>{parseDate(value, DateTimeStandard.DisplayDateOfMonth)}</Box>;
            },
        },
        {
            cellKey: 'shippingDayText',
            headerLabel: '出貨週期',
            align: 'center',
            formatCell: (value) => {
                return `${value}日`;
            },
        },
        {
            cellKey: 'totalAmount',
            headerLabel: '總筆數',
            align: 'center',
        },
        {
            cellKey: 'totalPrice',
            headerLabel: '總金額',
            align: 'center',
        },
        {
            cellKey: 'settleSuccessAmount',
            headerLabel: '扣款成功筆數',
            align: 'center',
            formatCell: (value) => {
                if (!value) return '-';
                return <Box className={'text-success'}>{value}</Box>;
            },
        },
        {
            cellKey: 'settleFailureAmount',
            headerLabel: '扣款失敗筆數',
            align: 'center',
            formatCell: (value) => {
                if (!value) return '-';
                return <Box className={'text-error'}>{value}</Box>;
            },
        },
        {
            cellKey: 'settleSuccessPrice',
            headerLabel: '實際扣款金額',
            align: 'right',
            formatCell: (value) => {
                if (!value) return '-';
                return formatCurrencyFn(value, '$');
            },
        },
        {
            cellKey: 'validateUserDisplayName',
            headerLabel: '檢核人員',
            align: 'center',
            formatCell: (value) => {
                if (!value) return '-';
                return value;
            },
        },
        {
            cellKey: 'settleUserDisplayName',
            headerLabel: '扣款人員',
            align: 'center',
            formatCell: (value) => {
                if (!value) return '-';
                return value;
            },
        },
        {
            cellKey: 'more',
            headerLabel: '',
            width: 6.8,
            formatCell: (value, { taskStatus, canSettle, canDelete, taskID }, { dialogRef, refresh }) => {
                const { openSettleCyclePurchaseTaskDialog, openDeleteCyclePurchaseTaskDialog, openReturnSettleCyclePurchaseTaskDialog } = dialogRef.current || {};
                const canView = String(taskStatus) === '3' || String(taskStatus) === '4';
                const canReturnSettle = String(taskStatus) === '12'; // 退單已驗證，僅此狀態可執行退單
                let menuData = [];
                if (canView) {
                    menuData = [
                        ...menuData,
                        {
                            text: '查看',
                            to: (e) => CYCLE_PURCHASE_BILLING_ROUTER_URL(taskID),
                        },
                    ];
                }
                if (canSettle) {
                    menuData = [
                        ...menuData,
                        {
                            text: '進行扣款',
                            onClick: () => isFunction(openSettleCyclePurchaseTaskDialog) && openSettleCyclePurchaseTaskDialog({ taskID }, refresh),
                        },
                    ];
                }
                if (canReturnSettle) {
                    menuData = [
                        ...menuData,
                        {
                            text: '執行退單',
                            onClick: () => isFunction(openReturnSettleCyclePurchaseTaskDialog) && openReturnSettleCyclePurchaseTaskDialog({ taskID }, refresh),
                        },
                    ];
                }
                if (canDelete) {
                    menuData = [
                        ...menuData,
                        {
                            text: '刪除',
                            onClick: () => isFunction(openDeleteCyclePurchaseTaskDialog) && openDeleteCyclePurchaseTaskDialog({ taskID }, refresh),
                        },
                    ];
                }
                if (isEmpty(menuData)) return null;
                return <OverflowMenu menuData={menuData} />;
            },
        },
    ];
};
